<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibition Center</BreadcrumbItem>
          <BreadcrumbItem to="/exhibitionEn/index/news">Company News</BreadcrumbItem>
          <BreadcrumbItem>Add company moments</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="f-tar" style="margin:36px 0;">
        <Button @click="$router.push('/exhibitionEn/index/news')">Back</Button>
      </div>
    </div>
    <div class="my-item">
      <div class="addcertificate">
        <div class="addcertificate-box">
          <div class="my-modal">
            <div class="my-modal-content">
              <Form ref="formInline" :label-width="130" :model="formInline" :rules="ruleInline">
                <FormItem label="Cover：" :required="true">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList"
                    :key="'upload' + index"
                    style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width:100%;height:100%;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width:100px;"
                    v-show="uploadList && uploadList.length < 1"
                  >
                    <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                      <div style="font-size:25px;">
                        +
                        <p style="font-size:14px;">Upload picture</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
                      @click.stop="selectType"
                    ></div>
                  </Upload>
                  <p style="font-size:12px;">(Requirements: .jpg/.png within 2M, suggested size is 260*170px)</p>
                </FormItem>
                <FormItem label="Title：" prop="title">
                  <Input v-model="formInline.title" placeholder="Please enter the news title" />
                </FormItem>
                <FormItem label="Abstract：" prop="summary">
                  <Input type="textarea" :rows="4" v-model="formInline.summary" placeholder="Please enther the news abstract" />
                </FormItem>
                <FormItem label="Content：" :required="true">
                  <div ref="editorElement"></div>
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    :loading="loading"
                    @click="handleSubmit('formInline')"
                    style="width:200px;height:35px;font-size:14px;"
                  >Save and submit to review</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <iModal title="View picture" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      fileType="img"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
  </div>
</template>

<script>
import axios from 'axios';
import wangeditor from "wangeditor";
import config from '@assets/config.json';
import { mapActions, mapGetters } from "vuex";
import uploadChoose from "@components/En/uploadChoose/uploadChoose";
import imgUpload from "@components/En/imgUpload/imgUpload.vue";
export default {
  name: "add-news",
  data() {
    return {
      editor: null,
      imgName: "",
      loading: false,
      formInline: {
        title: "", // 标题
        summary: "", // 概要
        content: "", // 内容
      },
      ruleInline: {
        // 效验规则
        title: [
          { required: true, message: "Please enter the news title", trigger: "blur" },
        ],
        summary: [
          { required: true, message: "Please enther the news abstract", trigger: "blur" }
        ],
      },
      uploadList: [],
      defaultList: [],
      visible: false,
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    })
  },
  methods: {
    ...mapActions({
      addNews: "addNews",
    }),
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${limitNum} image only`);
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit(name,e) {
      let form = this.formInline;
      let imgList = this.transfromImgList(this.uploadList);
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传资讯封面`);
        return;
      }
      if (!(this.formInline.content)) {
        this.$Message.error(`请输入资讯内容`);
        return;
      }
      let formData = {
        compId: this.company.id,
        compName: this.company.name,
        logo: this.company.logo,
        title: form.title,
        coverUrl: imgList[0],
        summary: form.summary,
        introduction: JSON.stringify(form.content)
      };
      if(form.SkipType === 'content') {
        req.setValues.SkipContent = JSON.stringify(form.SkipContent);
      }
      this.loading = true;
      let bool = await this.addNews(formData);
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("successful");
        this.$router.push("/exhibitionEn/index/news");
      } else {
        this.$Message.error("fail,please try again");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
  },
  mounted() {
    console.log("公司信息：",this.company);
    this.editor = new wangeditor(this.$refs.editorElement);
    this.editor.customConfig.zIndex = 1;
    // 赋值
    this.editor.customConfig.onchange = e => {
      this.formInline.content = e;
    };

    // 上传图片配置
    const that = this;
    this.editor.customConfig.customUploadImg = function (files, insert) {
      // console.log(files)
      files.forEach((item) => {
        let fd = new FormData();
        fd.append('file', item); // 上传的文件： 键名，键值
        axios.post(`${config.api.reqApi}/api/upload/images`, fd).then(data => {
        if (data.data.successed) {
          insert(data.data.list[0]);
        } else {
          that.$Message.error("上传失败，请重试！"); 
        }
      }).catch((err) => {
        that.$Message.error("上传失败，请重试！"); 
        console.log(err.response.data);
      });
      })
    }
    
    this.editor.customConfig.lang = {
      '设置标题': 'title',
      '正文': 'p',
      '字号': 'font-size',
      '字体': 'font',
      '文字颜色': 'text color',
      '背景色': 'background color',
      '链接文字': 'link text',
      '链接': 'link',
      '插入': 'insert',
      '设置列表': 'setting list',
      '有序列表': 'ordered list',
      '无序列表': 'unordered list',
      '对齐方式': 'alignment',
      '靠左': 'left',
      '居中': 'center',
      '靠右': 'right',
      '默认': 'default',
      '新浪': 'sina',
      '上传图片': 'upload image',
      '网络图片': 'online image',
      '图片': 'image ',
      '表格': ' table',
      '上传': 'upload',
      '创建': 'init',
      '行': 'line',
      '列': 'column',
      '的': '',
      '代码': ' code',
    };
    this.editor.customConfig.menus = [
      // 菜单配置
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      'backColor', // 背景颜色
      'link', // 插入链接
      'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      'emoticon', // 表情
      'image', // 插入图片
      'table', // 表格
      'code', // 插入代码
      'undo', // 撤销
      'redo' // 重复
    ];
    this.editor.create(); // 创建富文本实例

    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  },
  components: {
    uploadChoose,
    imgUpload,
  }
};
</script>

<style lang="scss" scoped>
.my-item {
  min-width: 1200px;
}
.addcertificate {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 1000px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.preview {
  cursor: pointer;
}
</style>